export const LOG_OUT = "@@AUTH/LOG_OUT";

export const GET_USER_PROFILE = "@@AUTH/GET_USER_PROFILE";
export const GET_USER_PROFILE_REQUEST = "@@AUTH/GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "@@AUTH/GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAILURE = "@@AUTH/GET_USER_PROFILE_FAILURE";

export const GET_USER_MEMBERSHIP = "@@AUTH/GET_USER_MEMBERSHIP";
export const GET_USER_MEMBERSHIP_REQUEST = "@@AUTH/GET_USER_MEMBERSHIP_REQUEST";
export const GET_USER_MEMBERSHIP_SUCCESS = "@@AUTH/GET_USER_MEMBERSHIP_SUCCESS";
export const GET_USER_MEMBERSHIP_FAILURE = "@@AUTH/GET_USER_MEMBERSHIP_FAILURE";

export const GET_MINDSET_IS_PAID = "@@AUTH/GET_MINDSET_IS_PAID";
export const GET_MINDSET_IS_PAID_REQUEST = "@@AUTH/GET_MINDSET_IS_PAID_REQUEST";
export const GET_MINDSET_IS_PAID_SUCCESS = "@@AUTH/GET_MINDSET_IS_PAID_SUCCESS";
export const GET_MINDSET_IS_PAID_FAILURE = "@@AUTH/GET_MINDSET_IS_PAID_FAILURE";

export const GET_USER_MEMBERSHIP_DETAILS = "@@AUTH/GET_USER_MEMBERSHIP_DETAILS";
export const GET_USER_MEMBERSHIP_DETAILS_REQUEST =
  "@@AUTH/GET_USER_MEMBERSHIP_DETAILS_REQUEST";
export const GET_USER_MEMBERSHIP_DETAILS_SUCCESS =
  "@@AUTH/GET_USER_MEMBERSHIP_DETAILS_SUCCESS";
export const GET_USER_MEMBERSHIP_DETAILS_FAILURE =
  "@@AUTH/GET_USER_MEMBERSHIP_DETAILS_FAILURE";

export const LOGIN = "@@AUTH/LOGIN";
export const LOGIN_REQUEST = "@@AUTH/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "@@AUTH/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "@@AUTH/LOGIN_FAILURE";

export const CHECK_EMAIL = "@@AUTH/CHECK_EMAIL";
export const CHECK_EMAIL_REQUEST = "@@AUTH/CHECK_EMAIL_REQUEST";
export const CHECK_EMAIL_SUCCESS = "@@AUTH/CHECK_EMAIL_SUCCESS";
export const CHECK_EMAIL_FAILURE = "@@AUTH/CHECK_EMAIL_FAILURE";

export const CHECK_EMAIL_AND_PASSWORD = "@@AUTH/CHECK_EMAIL_AND_PASSWORD";
export const CHECK_EMAIL_AND_PASSWORD_REQUEST =
  "@@AUTH/CHECK_EMAIL_AND_PASSWORD_REQUEST";
export const CHECK_EMAIL_AND_PASSWORD_SUCCESS =
  "@@AUTH/CHECK_EMAIL_AND_PASSWORD_SUCCESS";
export const CHECK_EMAIL_AND_PASSWORD_FAILURE =
  "@@AUTH/CHECK_EMAIL_AND_PASSWORD_FAILURE";

export const CHECK_USERNAME = "@@AUTH/CHECK_USERNAME";
export const CHECK_USERNAME_REQUEST = "@@AUTH/CHECK_USERNAME_REQUEST";
export const CHECK_USERNAME_SUCCESS = "@@AUTH/CHECK_USERNAME_SUCCESS";
export const CHECK_USERNAME_FAILURE = "@@AUTH/CHECK_USERNAME_FAILURE";

export const SIGNUP = "@@AUTH/SIGNUP";
export const SIGNUP_REQUEST = "@@AUTH/SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "@@AUTH/SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "@@AUTH/SIGNUP_FAILURE";

export const RESET_PASSWORD = "@@RESET_PASSWORD";
export const RESET_PASSWORD_REQUEST = "@@RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "@@RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "@@RESET_PASSWORD_FAILURE";

export const SET_USER_PROFILE = "@@AUTH/SET_USER_PROFILE";

export const CREATE_STRIPE_SESSION = "@@AUTH/CREATE_STRIPE_SESSION";
export const CREATE_STRIPE_SESSION_REQUEST =
  "@@AUTH/CREATE_STRIPE_SESSION_REQUEST";
export const CREATE_STRIPE_SESSION_SUCCESS =
  "@@AUTH/CREATE_STRIPE_SESSION_SUCCESS";
export const CREATE_STRIPE_SESSION_FAILURE =
  "@@AUTH/CREATE_STRIPE_SESSION_FAILURE";

export const CREATE_STRIPE_PAYMENT_INTENT =
  "@AUTH/CREATE_STRIPE_PAYMENT_INTENT";
export const CREATE_STRIPE_PAYMENT_INTENT_REQUEST =
  "@AUTH/CREATE_STRIPE_PAYMENT_INTENT_REQUEST";
export const CREATE_STRIPE_PAYMENT_INTENT_SUCCESS =
  "@AUTH/CREATE_STRIPE_PAYMENT_INTENT_SUCCESS";
export const CREATE_STRIPE_PAYMENT_INTENT_FAILURE =
  "@AUTH/CREATE_STRIPE_PAYMENT_INTENT_FAILURE";

export const SET_COUPON = "@@AUTH/SET_COUPON";
export const GET_COUPON_DETAILS = "@@AUTH/GET_COUPON_DETAILS";
export const GET_COUPON_DETAILS_REQUEST = "@@AUTH/GET_COUPON_DETAILS_REQUEST";
export const GET_COUPON_DETAILS_SUCCESS = "@@AUTH/GET_COUPON_DETAILS_SUCCESS";
export const GET_COUPON_DETAILS_FAILURE = "@@AUTH/GET_COUPON_DETAILS_FAILURE";

export const UPDATE_PROFILE = "@@AUTH/UPDATE_PROFILE";
export const UPDATE_PROFILE_REQUEST = "@@AUTH/UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "@@AUTH/UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "@@AUTH/UPDATE_PROFILE_FAILURE";

export const UPDATE_USER_AVATAR = "@@AUTH/UPDATE_USER_AVATAR";
export const UPDATE_USER_AVATAR_REQUEST = "@@AUTH/UPDATE_USER_AVATAR_REQUEST";
export const UPDATE_USER_AVATAR_SUCCESS = "@@AUTH/UPDATE_USER_AVATAR_SUCCESS";
export const UPDATE_USER_AVATAR_FAILURE = "@@AUTH/UPDATE_USER_AVATAR_FAILURE";

export const UPDATE_USER_EMAIL = "@@AUTH/UPDATE_USER_EMAIL";
export const UPDATE_USER_EMAIL_REQUEST = "@@AUTH/UPDATE_USER_EMAIL_REQUEST";
export const UPDATE_USER_EMAIL_SUCCESS = "@@AUTH/UPDATE_USER_EMAIL_SUCCESS";
export const UPDATE_USER_EMAIL_FAILURE = "@@AUTH/UPDATE_USER_EMAIL_FAILURE";

export const UPDATE_USER_PASSWORD = "@@AUTH/UPDATE_USER_PASSWORD";
export const UPDATE_USER_PASSWORD_REQUEST =
  "@@AUTH/UPDATE_USER_PASSWORD_REQUEST";
export const UPDATE_USER_PASSWORD_SUCCESS =
  "@@AUTH/UPDATE_USER_PASSWORD_SUCCESS";
export const UPDATE_USER_PASSWORD_FAILURE =
  "@@AUTH/UPDATE_USER_PASSWORD_FAILURE";

export const PAYMENT_UNSUBSCRIBE = "@@AUTH/PAYMENT_UNSUBSCRIBE";
export const PAYMENT_UNSUBSCRIBE_REQUEST = "@@AUTH/PAYMENT_UNSUBSCRIBE_REQUEST";
export const PAYMENT_UNSUBSCRIBE_SUCCESS = "@@AUTH/PAYMENT_UNSUBSCRIBE_SUCCESS";
export const PAYMENT_UNSUBSCRIBE_FAILURE = "@@AUTH/PAYMENT_UNSUBSCRIBE_FAILURE";

export const PAYMENT_RESUME_RENEWAL = "@@AUTH/PAYMENT_RESUME_RENEWAL";
export const PAYMENT_RESUME_RENEWAL_REQUEST =
  "@@AUTH/PAYMENT_RESUME_RENEWAL_REQUEST";
export const PAYMENT_RESUME_RENEWAL_SUCCESS =
  "@@AUTH/PAYMENT_RESUME_RENEWAL_SUCCESS";
export const PAYMENT_RESUME_RENEWAL_FAILURE =
  "@@AUTH/PAYMENT_RESUME_RENEWAL_FAILURE";

export const USER_DELETE_ACCOUNT = "@@AUTH/USER_DELETE_ACCOUNT";
export const USER_DELETE_ACCOUNT_REQUEST = "@@AUTH/USER_DELETE_ACCOUNT_REQUEST";
export const USER_DELETE_ACCOUNT_SUCCESS = "@@AUTH/USER_DELETE_ACCOUNT_SUCCESS";
export const USER_DELETE_ACCOUNT_FAILURE = "@@AUTH/USER_DELETE_ACCOUNT_FAILURE";

export const USER_CHANGE_LANGUAGE = "@@AUTH/USER_CHANGE_LANGUAGE";
export const USER_CHANGE_LANGUAGE_REQUEST =
  "@@AUTH/USER_CHANGE_LANGUAGE_REQUEST";
export const USER_CHANGE_LANGUAGE_SUCCESS =
  "@@AUTH/USER_CHANGE_LANGUAGE_SUCCESS";
export const USER_CHANGE_LANGUAGE_FAILURE =
  "@@AUTH/USER_CHANGE_LANGUAGE_FAILURE";

export const TOGGLE_DELETE_ACCOUNT_POPUP = "@@AUTH/TOGGLE_DELETE_ACCOUNT_POPUP";

export const FETCH_LIKED_CONTENT = "@@AUTH/FETCH_LIKED_CONTENT";
export const FETCH_LIKED_CONTENT_REQUEST = "@@AUTH/FETCH_LIKED_CONTENT_REQUEST";
export const FETCH_LIKED_CONTENT_SUCCESS = "@@AUTH/FETCH_LIKED_CONTENT_SUCCESS";
export const FETCH_LIKED_CONTENT_FAILURE = "@@AUTH/FETCH_LIKED_CONTENT_FAILURE";

export const LIKE_CONTENT = "@@AUTH/LIKE_CONTENT";
export const LIKE_CONTENT_REQUEST = "@@AUTH/LIKE_CONTENT_REQUEST";
export const LIKE_CONTENT_SUCCESS = "@@AUTH/LIKE_CONTENT_SUCCESS";
export const LIKE_CONTENT_FAILURE = "@@AUTH/LIKE_CONTENT_FAILURE";

export const UNLIKE_CONTENT = "@@AUTH/UNLIKE_CONTENT";
export const UNLIKE_CONTENT_REQUEST = "@@AUTH/UNLIKE_CONTENT_REQUEST";
export const UNLIKE_CONTENT_SUCCESS = "@@AUTH/UNLIKE_CONTENT_SUCCESS";
export const UNLIKE_CONTENT_FAILURE = "@@AUTH/UNLIKE_CONTENT_FAILURE";

export const FETCH_LIKED_PHOTOS = "@@AUTH/FETCH_LIKED_PHOTOS";
export const FETCH_LIKED_PHOTOS_REQUEST = "@@AUTH/FETCH_LIKED_PHOTOS_REQUEST";
export const FETCH_LIKED_PHOTOS_SUCCESS = "@@AUTH/FETCH_LIKED_PHOTOS_SUCCESS";
export const FETCH_LIKED_PHOTOS_FAILURE = "@@AUTH/FETCH_LIKED_PHOTOS_FAILURE";

export const LIKE_PHOTO = "@@AUTH/LIKE_PHOTO";
export const LIKE_PHOTO_REQUEST = "@@AUTH/LIKE_PHOTO_REQUEST";
export const LIKE_PHOTO_SUCCESS = "@@AUTH/LIKE_PHOTO_SUCCESS";
export const LIKE_PHOTO_FAILURE = "@@AUTH/LIKE_PHOTO_FAILURE";

export const UNLIKE_PHOTO = "@@AUTH/UNLIKE_PHOTO";
export const UNLIKE_PHOTO_REQUEST = "@@AUTH/UNLIKE_PHOTO_REQUEST";
export const UNLIKE_PHOTO_SUCCESS = "@@AUTH/UNLIKE_PHOTO_SUCCESS";
export const UNLIKE_PHOTO_FAILURE = "@@AUTH/UNLIKE_PHOTO_FAILURE";

export const GET_BRAINTREE_CLIENT_TOKEN = "@@AUTH/GET_BRAINTREE_CLIENT_TOKEN";
export const GET_BRAINTREE_CLIENT_TOKEN_REQUEST =
  "@@AUTH/GET_BRAINTREE_CLIENT_TOKEN_REQUEST";
export const GET_BRAINTREE_CLIENT_TOKEN_SUCCESS =
  "@@AUTH/GET_BRAINTREE_CLIENT_TOKEN_SUCCESS";
export const GET_BRAINTREE_CLIENT_TOKEN_FAILURE =
  "@@AUTH/GET_BRAINTREE_CLIENT_TOKEN_FAILURE";

export const CREATE_BRAINTREE_SUBSCRIPTION =
  "@@AUTH/CREATE_BRAINTREE_SUBSCRIPTION";
export const CREATE_BRAINTREE_SUBSCRIPTION_REQUEST =
  "@@AUTH/CREATE_BRAINTREE_SUBSCRIPTION_REQUEST";
export const CREATE_BRAINTREE_SUBSCRIPTION_SUCCESS =
  "@@AUTH/CREATE_BRAINTREE_SUBSCRIPTION_SUCCESS";
export const CREATE_BRAINTREE_SUBSCRIPTION_FAILURE =
  "@@AUTH/CREATE_BRAINTREE_SUBSCRIPTION_FAILURE";

export const GET_SIGNED_COOKIES = "@@AUTH/GET_SIGNED_COOKIES";
export const GET_SIGNED_COOKIES_REQUEST = "@@AUTH/GET_SIGNED_COOKIES_REQUEST";
export const GET_SIGNED_COOKIES_SUCCESS = "@@AUTH/GET_SIGNED_COOKIES_SUCCESS";
export const GET_SIGNED_COOKIES_FAILURE = "@@AUTH/GET_SIGNED_COOKIES_FAILURE";

export const GET_STRIPE_PROMO_CODE = "@@AUTH/GET_STRIPE_PROMO_CODE";
export const GET_STRIPE_PROMO_CODE_REQUEST =
  "@@AUTH/GET_STRIPE_PROMO_CODE_REQUEST";
export const GET_STRIPE_PROMO_CODE_SUCCESS =
  "@@AUTH/GET_STRIPE_PROMO_CODE_SUCCESS";
export const GET_STRIPE_PROMO_CODE_FAILURE =
  "@@AUTH/GET_STRIPE_PROMO_CODE_FAILURE";
export const RESET_STRIPE_PROMO_CODE = "@@AUTH/RESET_STRIPE_PROMO_CODE";

export const CREATE_STRIPE_SETUP_INTENT = "@@AUTH/CREATE_STRIPE_SETUP_INTENT";
export const CREATE_STRIPE_SETUP_INTENT_REQUEST =
  "@@AUTH/CREATE_STRIPE_SETUP_INTENT_REQUEST";
export const CREATE_STRIPE_SETUP_INTENT_SUCCESS =
  "@@AUTH/CREATE_STRIPE_SETUP_INTENT_SUCCESS";
export const CREATE_STRIPE_SETUP_INTENT_FAILURE =
  "@@AUTH/GET_STRIPE_SETUP_INTENT_FAILURE";

export const TOGGLE_SHOW_PROMO_CODE = "@@AUTH/TOGGLE_SHOW_PROMO_CODE";
export const REMOVE_PROMO_CODE = "@@AUTH/REMOVE_PROMO_CODE";
